import { useCallback, useState } from 'react';
import useApiClient from './useApiClient';

export type Promotion = {
  id: number;
  title: string | null;
  description: string;
  imageUrl: string;
  linkUrl: string | null;
  confirmButtonLabel: string;
  dismissButtonLabel: string;
};

export default function usePromotion() {
  const { apiClient } = useApiClient();
  const [queue, setQueue] = useState<Promotion[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  // priority 昇順で取得済みのキューの先頭が現在表示対象
  const promotion = queue[0] ?? null;

  const fetchPromotions = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await apiClient('/api/promotions', { method: 'GET' });
      if (res.ok) {
        const data = await res.json();
        setQueue(data.promotions ?? []);
      }
    } finally {
      setIsLoading(false);
      setIsFetched(true);
    }
  }, [apiClient]);

  /** 現在表示中のプロモーション（先頭）をキューから取り除く */
  const dequeue = useCallback(() => {
    setQueue((prev: Promotion[]) => prev.slice(1));
  }, []);

  /** キューを空にする（ログアウト時など） */
  const clearQueue = useCallback(() => {
    setQueue([]);
    setIsFetched(false);
  }, []);

  const recordAction = useCallback(
    async (promotionId: number, actionType: string) => {
      await apiClient('/api/promotions/action', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ promotionId, actionType }),
      });
    },
    [apiClient],
  );

  return {
    promotion,
    fetchPromotions,
    dequeue,
    clearQueue,
    recordAction,
    isLoading,
    isFetched,
  };
}
